import { createSlice } from '@reduxjs/toolkit';
import { getLegacyCitas, getLegacyRecepcionesVehiculos, createLegacyRecepcionVehiculo } from '../legacy/thunk';

export const initialState = {
    citas: [],
    recepcionesVehiculos: [],
    loading: false,
    error: {},
};

const recepcionVehiculosSlice = createSlice({
    name: 'recepcionVehiculos',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getLegacyCitas.fulfilled, (state, action) => {
            state.citas = action.payload;
            state.loading = false;
        });
        builder.addCase(getLegacyCitas.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.loading = false;
        });
        builder.addCase(getLegacyCitas.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        //
        builder.addCase(getLegacyRecepcionesVehiculos.fulfilled, (state, action) => {
            state.recepcionesVehiculos = action.payload;
            state.loading = false;
        });
        builder.addCase(getLegacyRecepcionesVehiculos.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.loading = false;
        });
        builder.addCase(getLegacyRecepcionesVehiculos.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        builder.addCase(createLegacyRecepcionVehiculo.fulfilled, (state, action) => {
            state.recepcionesVehiculos.push(action.payload);
            state.loading = false;
        });
        builder.addCase(createLegacyRecepcionVehiculo.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.loading = false;
        });
        builder.addCase(createLegacyRecepcionVehiculo.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
    }
});

export default recepcionVehiculosSlice.reducer;